


// export const baseUrl = "http://localhost:8000";
// export const socketUrl = "http://localhost:8001";

export const baseUrl = "https://api.itoex.io";
export const socketUrl = "wss://stream.itoex.io/";